import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Iter 574 (Kamel) — choix de l'assurance depuis l'espace (fiche express : rien n'avait été demandé à l'inscription)
const ChoixAssurance = ({ token, d, onDone }) => {
  const [busy, setBusy] = useState('');
  const total = (d.assurance_tarif || 0) * (d.nb_voyageurs || 1);
  const choisir = async (choix) => {
    const msg = choix === 'oui'
      ? `Souscrire l'assurance multirisque pour ${d.nb_voyageurs} voyageur(s) : ${total.toLocaleString('fr-FR')} € (${d.assurance_tarif} €/pers.) ajoutés au total du voyage ?`
      : "Refuser l'assurance ? En cas d'annulation de votre part, les frais d'annulation resteront intégralement à votre charge.";
    if (!window.confirm(msg)) return;
    setBusy(choix);
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/fiche/${d.reg_id}/assurance`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ choix }),
      });
      const j = await r.json();
      if (!r.ok) alert(j.detail || 'Erreur');
      else onDone?.(choix === 'oui' ? `✅ Assurance souscrite (${total.toLocaleString('fr-FR')} €). Votre facture est à jour.` : '✅ Choix enregistré : sans assurance.');
    } catch { alert('Erreur réseau'); }
    setBusy('');
  };
  if (!d.assurance_tarif) return <span className="ml-auto text-[11px] text-gray-500 italic">Tarif à confirmer par l'association</span>;
  return (
    <span className="ml-auto flex gap-1">
      <button type="button" onClick={() => choisir('oui')} disabled={!!busy} data-testid={`dossier-avion-assurance-oui-${d.reg_id}`}
        className="text-xs font-bold text-white bg-emerald-600 px-2.5 py-1.5 rounded-lg disabled:opacity-50">🛡️ Oui, {d.assurance_tarif} €/pers.</button>
      <button type="button" onClick={() => choisir('non')} disabled={!!busy} data-testid={`dossier-avion-assurance-non-${d.reg_id}`}
        className="text-xs font-bold text-red-700 bg-white border border-red-300 px-2.5 py-1.5 rounded-lg disabled:opacity-50">Non</button>
    </span>
  );
};

// Iter 527 (Kamel) — ✈️ Dossier avion : progression + coach, dans l'Espace Adhérent.
const DossierAvion = ({ dossiers, fiches, token, onChanged }) => {
  if (!dossiers?.length) return null;
  return (
    <div className="space-y-3" data-testid="dossiers-avion">
      {dossiers.map(d => {
        const fiche = (fiches || []).find(f => f.reg_id === d.reg_id);
        const lienBillet = fiche?.pieces?.lien ? fiche.pieces.lien.replace(/^https?:\/\/[^/]+/, '') : null;
        return (
          <div key={d.reg_id} className={`rounded-2xl border-2 p-4 space-y-2 ${d.pourcentage === 100 ? 'border-emerald-300 bg-emerald-50' : 'border-sky-300 bg-white'}`} data-testid={`dossier-avion-${d.reg_id}`}>
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <p className="font-bold text-[#1E3A5F]">✈️ Mon dossier — {d.voyage}</p>
              {d.jours != null && <span className="text-xs font-bold text-gray-600">Départ dans {d.jours} jours</span>}
            </div>
            <div className="flex items-center gap-2">
              <div className="flex-1 h-3 rounded-full bg-gray-200 overflow-hidden"><div className="h-full bg-emerald-500 transition-all" style={{ width: `${d.pourcentage}%` }} /></div>
              <span className="text-sm font-bold text-emerald-700" data-testid={`dossier-avion-pct-${d.reg_id}`}>{d.pourcentage} %</span>
            </div>
            <p className="text-sm text-gray-800 bg-amber-50 border border-amber-200 rounded-xl p-2.5" data-testid={`dossier-avion-coach-${d.reg_id}`}>{d.coach}</p>
            <ul className="text-sm space-y-1">
              {d.etapes.map(e => (
                <li key={e.key} className="flex items-center gap-2 flex-wrap" data-testid={`dossier-avion-etape-${e.key}-${d.reg_id}`}>
                  <span className={`inline-flex h-5 w-5 rounded-full items-center justify-center text-[11px] font-bold ${e.fait ? 'bg-emerald-500 text-white' : 'bg-gray-200 text-gray-500'}`}>{e.fait ? '✓' : ''}</span>
                  <span className={e.fait ? 'line-through text-gray-400' : 'text-gray-800'}>{e.label}</span>
                  {!e.fait && e.key === 'identite' && lienBillet && <Link to={lienBillet} className="ml-auto text-xs font-bold text-white bg-[#1E3A5F] px-3 py-1.5 rounded-lg" data-testid={`dossier-avion-billet-${d.reg_id}`}>Saisir →</Link>}
                  {!e.fait && (e.key === 'acompte' || e.key === 'solde') && <a href="#rubrique-reglements" className="ml-auto text-xs font-bold text-white bg-emerald-600 px-3 py-1.5 rounded-lg">Régler →</a>}
                  {!e.fait && e.key === 'adresse' && <a href={`#fiche-infos-${d.reg_id}`} className="ml-auto text-xs font-bold text-white bg-[#1E3A5F] px-3 py-1.5 rounded-lg" data-testid={`dossier-avion-adresse-${d.reg_id}`}>Compléter →</a>}
                  {!e.fait && e.key === 'assurance' && token && <ChoixAssurance token={token} d={d} onDone={(m) => { alert(m); onChanged?.(); }} />}
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default DossierAvion;
